<script setup>
  import NormalInput from './NormalInput.vue';
  import RichTextEditor from './RichTextEditor.vue';
  import ClientHiringTeamSelector from './ClientHiringTeamSelector.vue';
  import FileUploadSingle from './FileUploadSingle.vue';
  import FileUploadMultiple from './FileUploadMultiple.vue';
  import ButtonSubmit from './ButtonSubmit.vue';
  import LinkSecondary from './LinkSecondary.vue';
  import AssetLibraryManager from './AssetLibrary/AssetLibraryManager.vue';

  const csrf = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

  const props = defineProps({
    action: {
      type: String,
      required: true
    },
    backUrl: {
      type: String,
      default: '/clients'
    },
    method: {
      type: String,
      default: 'POST'
    },
    client: {
      type: Object,
      default: null
    },
    recruiters: {
      type: Array,
      default: () => []
    },
    admins: {
      type: Array,
      default: () => []
    },
    errors: {
      type: Object,
      default: () => ({})
    },
    oldInput: {
      type: Object,
      default: () => ({})
    }
  });

</script>

<template>

<form
  method="POST"
  :action="action"
  enctype="multipart/form-data"
>
  <input type="hidden" name="_method" :value="method">
  <input type="hidden" name="_token" :value="csrf" autocomplete="off">

  <NormalInput
    :value="'name' in oldInput ? oldInput.name : client?.name"
    :error="errors.name?.[0]"
    label="Client Name"
    name="name"
    dusk="name"
  >
  </NormalInput>

  <RichTextEditor
    :value="'raw_description' in oldInput ? JSON.parse(oldInput.raw_description) : client?.raw_description"
    :error="errors.raw_description?.[0]"
    name="raw_description"
    dusk="description"
  >
    <template #label>Client Profile</template>
  </RichTextEditor>

  <ClientHiringTeamSelector
    :default-team-selector="true"
    :recruiters="recruiters"
    :admins="admins"
    :selected-client="client ?? {}"
    :selected-managers="client?.default_managers ?? []"
    :selected-recruiters="client?.default_recruiters ?? []"
    :selected-admins="client?.default_admins ?? []"
    :managers-error="errors.managers?.[0]"
    :recruiters-error="errors.recruiters?.[0]"
    :admins-error="errors.admins?.[0]"
    :old-input="oldInput"
  ></ClientHiringTeamSelector>

  <FileUploadSingle
    label="Client Logo"
    name="logo"
    dusk="logo"
    instructions="Use a png or svg logo with transparency for best results"
    mimes="image/*"
  >
    <template #icon>
      <span
        v-if="client?.logo"
        class="h-12 w-12 overflow-hidden"
      >
        <img
          class="h-full"
          :src="client.logo"
        >
      </span>
    </template>
  </FileUploadSingle>

  <AssetLibraryManager
    :model="client"
  />

  <div class="mt-8 border-t border-gray-200 pt-5">
    <div class="flex justify-end">
      <LinkSecondary
        href="/clients"
      >
        Cancel
      </LinkSecondary>

      <ButtonSubmit dusk='submit'>
        Save
      </ButtonSubmit>
    </div>
  </div>
</form>


</template>


